import AbstractPageBaseController from '../../../modules/core/abstracts/controllers/page-controller';

export default class SeatplansListController extends AbstractPageBaseController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.store = this.injector.get('Seatplans');
        this.store.commit('setVm', this);
        this.store.dispatch('loadWorkflows', 'seatplans');
    }

    addNew() {
        this.state.go('app.seatplans.create', {store: vm.store});
    }

    showSeatplan(payload) {
        this.state.go('app.seatplans.details', {id: payload.row.id, store: vm.store});
    }

    deleteSeatplan(payload) {
        payload.row.doDELETE().then(() => {
            this.store.dispatch('getData');
        }, function (response) {
            console.log(response);
        });
    }

    editSeatplan(payload) {
        this.state.go('app.seatplans.edit', {id: payload.row.id, seatplan: payload.row, store: vm.store});
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/controllers/seatplans-lists-controller.js